var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { sortByFunc } from '../../../../utils/helper/lodash_replacements';
import { sortedSet } from '../../../../utils/mobx/decorators/customComputed';
export class SortableListItems {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get sortableList() {
        return this.parent;
    }
    get question() {
        return this.sortableList.question;
    }
    get visibleSortableItems() {
        const ownItems = this.question.sortableUI.visibleSortableState.sortableItemStates
            .filter(sortableItem => sortableItem.droppableId === this.sortableList.id_string)
            .sort(sortByFunc((sortableItem) => sortableItem.indexInDroppable))
            .map(item => this.question.sortableStore.getItemById(item.sortableItemId));
        return ownItems;
    }
    get currentSortableItems() {
        const ownItems = this.question.sortableStore.sortableItems
            .filter(sortableItem => sortableItem.droppableId === this.sortableList.id_string)
            .sort(sortByFunc((sortableItem) => sortableItem.indexInDroppable));
        return ownItems;
    }
    insertToIndex(sortableItem, destinationIndex) {
        return this.currentSortableItems.slice(destinationIndex).forEach(sortableItem => sortableItem.indexInDroppable++);
        sortableItem.droppableId = this.sortableList.id_string;
        sortableItem.indexInDroppable = destinationIndex;
    }
    removeFromIndex(sortableItem, sourceIndex) {
        return this.currentSortableItems.slice(sourceIndex + 1).forEach(sortableItem => sortableItem.indexInDroppable--);
        sortableItem.droppableId = '';
        sortableItem.indexInDroppable = 0;
    }
}
__decorate([
    sortedSet
], SortableListItems.prototype, "visibleSortableItems", null);
__decorate([
    sortedSet
], SortableListItems.prototype, "currentSortableItems", null);
__decorate([
    action.bound
], SortableListItems.prototype, "insertToIndex", null);
__decorate([
    action.bound
], SortableListItems.prototype, "removeFromIndex", null);
